import each from 'lodash/each';
import $ from 'jquery';
import Vue from 'vue';
import eventBus from './eventBus';

/**
 * Set up photo galleries in the container.
 *
 * @param {HTMLElement} container
 */
function setupPhotoGalleries(container) {
  const $container = $(container);
  if (!$container.length) {
    return;
  }

  $container.find('a[href^="#lightbox-"]').each((idx, anchor) => {
    const $anchor = $(anchor);
    const galleryId = $anchor.attr('href');

    $anchor.on('click', (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      eventBus.$emit('open-lightbox', galleryId);
    });
  });

  each(container.querySelectorAll('.cms-photo-gallery'), (el) => {
    new Vue({ el });
  });
}

// eslint-disable-next-line import/prefer-default-export
export { setupPhotoGalleries };
